import React, { useState, useEffect } from 'react';
import { default as MuiCarousel } from 'react-simply-carousel';

import { styled } from '@mui/material/styles';
import carouselStyles from './ImageCarouselStyles';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

type CarouselImage = {
  src: string;
  alt: string;
};

type CarouselProps = {
  images: CarouselImage[];
};

const StyledCarousel = styled('div')(({ theme }) => carouselStyles);

const Carousel:React.FC<CarouselProps> = ({ images }) => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [width, setWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);


  const isMobile = width <= 1024;

  const imageContainerClassName = `w-[20rem] p-8 flex md:w-[25rem] lg:w-[25rem] xl:w-[35rem]`;

  return (
    <StyledCarousel className='flex flex-col items-center mb-20 lg:mb-32'>
      <MuiCarousel
        containerProps={{
          className: "carousel-container"
        }}
        activeSlideIndex={activeSlideIndex}
        autoplay={true}
        autoplayDelay={5000}
        onRequestChange={setActiveSlideIndex}
        itemsToShow={1}
        centerMode
        preventScrollOnSwipe
        itemsToScroll={1}
        forwardBtnProps={{
          children: <KeyboardArrowRightIcon />,
          className: `${isMobile && 'hidden'} carousel-arrow carousel-right-arrow`
        }}
        backwardBtnProps={{
          children: <KeyboardArrowLeftIcon />,
          className: `${isMobile && 'hidden'} carousel-arrow carousel-left-arrow`
        }}
        dotsNav={{
          show: true,
          itemBtnProps: {
            className: 'carousel-dots',
          },
          activeItemBtnProps: {
            className: 'carousel-dots carousel-active-dot'
          }
        }}
        speed={800}
        easing="ease-in-out"
      >
        {images.map((image, index) => (
          <div key={index} className={imageContainerClassName}>
            <div className='w-full rounded-lg overflow-hidden relative'>
              <img loading="lazy" src={image.src} alt={image.alt} className='w-full h-full object-cover'/>
            </div>
          </div>
        ))}
      </MuiCarousel>
    </StyledCarousel>
  )
}

export default Carousel;